const isRn =
  typeof document !== "undefined" &&
  !!document.cookie.includes("isreactnative");

export const isRnTablet =
  typeof document !== "undefined" &&
  !!document.cookie.includes("isreactnativetablet");

export default isRn;
